
// ============================================
// MemberDetailScene - メンバー詳細ページシーン
// ============================================

/**
 * GNS.MemberDetailScene
 * * メンバー詳細ページのメイン制御クラス
 * HTMLのクラス名からメンバーIDを特定し、詳細情報を表示するコンテナを管理
 */
GNS.MemberDetailScene = function (GNS) {
    // AbstractSceneを継承
    const scene = GNS.create(GNS.AbstractScene);

    /**
     * 初期化処理
     */
    scene.init = function (data) {
        scene._super.init.call(this, data);

        this.memberId = null;     // 旧 this.page
        this.memberButtons = [];  // 旧 this.playerArray (関連メンバー表示用などを想定)

        // クラス名からメンバーIDを抽出するロジック
        // 例: class="... member_detail--12 ..." -> 12 を取得
        this._extractMemberId();

        // 詳細情報を挿入するコンテナ要素
        this.container = new GNS.DisplayObject("member__insert");
    };

    /**
     * クラス名解析ヘルパー
     */
    scene._extractMemberId = function () {
        const className = this.element.className || "";

        // 正規表現で "member_detail--" に続く数字を検索
        const match = className.match(/member_detail--(\d+)/);

        if (match && match[1]) {
            this.memberId = parseInt(match[1], 10);
        }
    };

    /**
     * ロード処理
     */
    scene.load = function () {
        // 必要であればここで個別のアセットロードなどを実装
        this._loadComplete();
    };

    /**
     * ロード完了時の処理
     */
    scene._bind._loadComplete = function () {
        // 現在は親クラスのロード処理を呼ぶのみ
        // 将来的にAjaxで詳細情報を取得する場合などはここに記述
        scene._super.load.call(this);
    };

    /**
     * 表示ハンドラ (Interface impl)
     */
    scene.showHandler = function () {
        // 実装なし
    };

    /**
     * 非表示ハンドラ (Interface impl)
     */
    scene.hideHandler = function () {
        // 実装なし
    };

    /**
     * リセットハンドラ (Interface impl)
     */
    scene.resetHandler = function () {
        // 実装なし
    };

    return scene._self;
}(GNS);
